import { render } from "./CreateAccount.vue?vue&type=template&id=8e10ad0c"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"

import "./CreateAccount.vue?vue&type=style&index=0&id=8e10ad0c&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__